import { Component } from 'react';
import { NavMarker } from 'react-rhumb';
import PropTypes from 'prop-types';
import { Flex } from 'foundations-components/components/Flex';
import ViewContainerContext from '../../containers/ViewContainerContext';
import PresentationRecord from '../../records/PresentationRecord';
import LegalConsentRecord from '../../records/LegalConsentRecord';
import ViewToolbar from './ViewToolbar';
import ViewContent from './ViewContent';
import PreviewAlert from './PreviewAlert';
import UTMBanner from './UTMBanner';
import { ViewerInfoModal } from './ViewerInfoModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class PublicView extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      pageDrawerOpen: true,
      viewerInfoSubmitted: false
    };
    this.handlePageDrawerToggle = () => {
      this.setState(({
        pageDrawerOpen
      }) => ({
        pageDrawerOpen: !pageDrawerOpen
      }));
    };
    this.handleViewerInfoSubmit = viewerInfo => {
      const {
        onIdentifyViewer,
        presentation
      } = this.props;
      onIdentifyViewer(presentation, viewerInfo);
      this.setState({
        viewerInfoSubmitted: true
      });
    };
    this.renderPreviewAlert = () => {
      const context = this.context;
      if (!context.isPreview) {
        return null;
      }
      return /*#__PURE__*/_jsx("div", {
        "data-test-id": "preview-alert",
        children: /*#__PURE__*/_jsx(PreviewAlert, {
          deckId: this.props.presentation.id
        })
      });
    };
    this.renderUTM = () => {
      if (!this.props.presentation.brandingMetadata.showSalesAd) {
        return null;
      }
      return /*#__PURE__*/_jsx(UTMBanner, {});
    };
  }
  componentDidMount() {
    const context = this.context;
    const {
      isPreview
    } = context;
    const {
      onIdentifyViewer,
      onFinishActivity,
      presentation,
      requiresViewerInfo
    } = this.props;
    if (!isPreview) {
      window.onbeforeunload = () => onFinishActivity();
      if (!requiresViewerInfo) {
        onIdentifyViewer(presentation);
      }
    }
  }
  render() {
    const {
      presentation,
      meetingLink,
      fetchDownloadLink,
      requiresViewerInfo,
      legalConsent
    } = this.props;
    const {
      pageDrawerOpen,
      viewerInfoSubmitted
    } = this.state;
    return /*#__PURE__*/_jsxs(Flex, {
      "data-test-id": "public-view",
      flexDirection: "column",
      position: "relative",
      blockSize: "100%",
      children: [/*#__PURE__*/_jsx(NavMarker, {
        name: "PREVIEW_LOAD"
      }), requiresViewerInfo && !viewerInfoSubmitted && /*#__PURE__*/_jsx(ViewerInfoModal, {
        legalConsent: legalConsent,
        givenName: presentation.user.firstName,
        familyName: presentation.user.lastName,
        accessId: presentation.accessId,
        presentationId: presentation.id,
        onConfirm: viewerInfo => this.handleViewerInfoSubmit(viewerInfo)
      }), /*#__PURE__*/_jsxs("div", {
        style: {
          position: 'relative'
        },
        children: [/*#__PURE__*/_jsx("div", {
          id: "public-view-fire-alarm-container"
        }), /*#__PURE__*/_jsx(ViewToolbar, {
          presentation: presentation,
          meetingLink: meetingLink,
          fetchDownloadLink: fetchDownloadLink,
          onPageDrawerToggle: this.handlePageDrawerToggle
        })]
      }), this.renderPreviewAlert(), /*#__PURE__*/_jsx(ViewContent, {
        presentation: presentation,
        file: presentation.pdfUrl,
        pageDrawerOpen: pageDrawerOpen
      }), this.renderUTM()]
    });
  }
}
PublicView.contextType = ViewContainerContext;
PublicView.propTypes = {
  presentation: PropTypes.instanceOf(PresentationRecord).isRequired,
  meetingLink: PropTypes.string,
  onIdentifyViewer: PropTypes.func,
  onFinishActivity: PropTypes.func,
  fetchDownloadLink: PropTypes.func.isRequired,
  requiresViewerInfo: PropTypes.bool,
  legalConsent: PropTypes.instanceOf(LegalConsentRecord)
};